import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { SaleResponse } from 'src/app/models/sale.model';
import { VendorResponse } from 'src/app/models/vendor.model';
import { PurchasesService } from 'src/app/services/purchases.service';
import { SalesService } from 'src/app/services/sales.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-modal-invoice-sale',
  templateUrl: './modal-invoice-sale.component.html',
  styleUrls: ['./modal-invoice-sale.component.scss']
})
export class ModalInvoiceSaleComponent {
  @Input() newSale = new SaleResponse();
  loading = false;
  @Input() newVendor = new VendorResponse();
  @Output() close = new EventEmitter<boolean>();
  creating = false;
  @Input() isCreating = false;
  @Input() isClient = true;
  inputs = {
    client: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  };
  filter: VendorResponse[] = [];
  timeoutWrite = null;
  editedClient: any = null;

  constructor(
    private saleService: SalesService,
    private toastService: ToastrService,
    private vendorService: VendorService,
    private purchaseService: PurchasesService
  ) {
  }

  ngOnInit(): void {
    if (this.isClient) {
      this.getInitClient(this.newSale.client);
    } else {
      this.getInitClient(this.newSale['provider']);
    }
  }

  createVendor() {
    this.newVendor = new VendorResponse();
    this.creating = true;
  }

  getInitClient(clientId: number) {
    this.inputs.client.class = "typing";
    this.inputs.client.verified = true;
    if (this.isClient) {
      this.vendorService.getClientsByClue('').subscribe({
        next: (response: ResponseObject) => {
          this.filter = response.data;
          var temp = this.filter.find((c) => {
            return c.id == clientId
          });
          console.log(temp);

          if (temp) {
            this.editedClient = temp;
            this.inputs.client.value = temp.name;
            this.inputs.client.verified = true;
            this.inputs.client.class = "fa-circle-check";
          } else {
            this.editedClient = null;
            this.inputs.client.value = '';
            this.inputs.client.verified = false;
            this.inputs.client.class = "fa-asterisk";
          }
        },
        error: (error: HttpErrorResponse) => {
          this.editedClient = null;
          this.inputs.client.value = '';
          this.inputs.client.verified = false;
          this.inputs.client.class = "fa-asterisk";
          if (error.status == 400) {
            this.toastService.error(error.error.message);
          } else {
            this.toastService.error("Error al obtener el cliente inicial");
          }
        }
      })
    } else {
      this.vendorService.getProvidesByClue('').subscribe({
        next: (response: ResponseObject) => {
          this.filter = response.data;
          var temp = this.filter.find((c) => {
            return c.id == clientId
          });
          console.log(temp);
          
          if (temp) {
            this.editedClient = temp;
            this.inputs.client.value = temp.name;
            this.inputs.client.verified = true;
            this.inputs.client.class = "fa-circle-check";
          } else {
            this.editedClient = null;
            this.inputs.client.value = '';
            this.inputs.client.verified = false;
            this.inputs.client.class = "fa-asterisk";
          }
        },
        error: (error: HttpErrorResponse) => {
          this.editedClient = null;
          this.inputs.client.value = '';
          this.inputs.client.verified = false;
          this.inputs.client.class = "fa-asterisk";
          if (error.status == 400) {
            this.toastService.error(error.error.message);
          } else {
            this.toastService.error("Error al obtener el cliente inicial");
          }
        }
      })
    }
  }

  writeClient(input: any) {
    var inputValue = input.srcElement.value;
    this.inputs.client.class = "typing";
    clearTimeout(this.timeoutWrite);
    this.timeoutWrite = setTimeout(() => {
      if (inputValue) {
        if (this.isClient){
          this.vendorService.getClientsByClue(inputValue).subscribe({
            next: (response: ResponseObject) => {
              this.filter = response.data;
              if (this.filter.length == 1) {
                this.editedClient = this.filter[0];
                this.inputs.client.value = this.filter[0].name;
                this.inputs.client.verified = true;
                this.inputs.client.class = "fa-circle-check";
              } else {
                this.newSale.client = null;
                this.inputs.client.verified = false;
                if (this.filter.length == 0) {
                  this.inputs.client.class = "fa-xmark";
                } else {
                  this.inputs.client.class = "fa-list";
                }
              }
            },
            error: (error: HttpErrorResponse) => {
              if (error.status == 400) {
                this.toastService.error(error.error.message);
              } else {
                this.toastService.error("Error al obtener el cliente");
              }
            }
          })
        } else {
          
        this.vendorService.getProvidesByClue(inputValue).subscribe({
          next: (response: ResponseObject) => {
            this.filter = response.data;
            if (this.filter.length == 1) {
              this.editedClient = this.filter[0];
              this.inputs.client.value = this.filter[0].name;
              this.inputs.client.verified = true;
              this.inputs.client.class = "fa-circle-check";
            } else {
              this.newSale.client = null;
              this.inputs.client.verified = false;
              if (this.filter.length == 0) {
                this.inputs.client.class = "fa-xmark";
              } else {
                this.inputs.client.class = "fa-list";
              }
            }
          },
          error: (error: HttpErrorResponse) => {
            if (error.status == 400) {
              this.toastService.error(error.error.message);
            } else {
              this.toastService.error("Error al obtener el cliente");
            }
          }
        })
        }
      } else {
        this.newSale.client = null;
        this.inputs.client.verified = false;
        this.inputs.client.class = "fa-asterisk";
      }
    }, 500);
  }

  check(vendor: any) {
    this.editedClient = vendor;
    this.inputs.client.value = vendor.name;
    this.inputs.client.verified = true;
    this.inputs.client.class = "fa-circle-check";
  }

  changeClient(client: any) {
    console.log(client);

  }

  putInvoice() {
    this.loading = true;
    var newData;
    if (this.isClient){
      newData = {
        date: this.newSale.date,
        series: this.newSale.series,
        number: this.newSale.number,
        lot: this.newSale.lot,
        clientId: this.editedClient.id,
        description: this.newSale.description
      }
      this.saleService.putInvoice(this.newSale.id, newData).subscribe({
        next: (response: ResponseObject) => {
          console.log(response);
          this.toastService.success('Factura editada correctamente!');
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          if (error.status == 400) {
            this.toastService.error(error.error.message);
          } else {
            this.toastService.error("Error al editar la factura");
          }
        }
      })
    } else {
      newData = {
        date: this.newSale.date,
        series: this.newSale.series,
        number: this.newSale.number,
        lot: this.newSale.lot,
        providerId: this.editedClient.id,
        description: this.newSale.description
      }
      this.purchaseService.putInvoice(this.newSale.id, newData).subscribe({
        next: (response: ResponseObject) => {
          console.log(response);
          this.toastService.success('Factura editada correctamente!');
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          if (error.status == 400) {
            this.toastService.error(error.error.message);
          } else {
            this.toastService.error("Error al editar la factura");
          }
        }
      })
    }
  }
}
